<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Prodigal Daughter</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="chaptitle-pre"><img alt="dot.jpg" src="images/dot.jpg"/>   <em class="italic">Contents</em></p>
<p class="toc1"><a href="#/07_part1"><span class="bolditalic">PART ONE</span>   <img alt="dot1.jpg" src="images/dot1.jpg"/>  <span class="bolditalic"> Demetrius among the Slavs</span></a></p>
<p class="toc2"><a href="#/08_prechap_04">Map</a></p>
<p class="toc2"><a href="#/09_Chapter_01">Prologue</a></p>
<p class="toc2"><a href="#/10_Chapter_02">Byzantium on the Prairies</a></p>
<p class="toc2"><a href="#/11_Chapter_03">Hiking for Demetrius</a></p>
<p class="toc2"><span href="#/12_Chapter_04" title="Link target outside of Sample">Mother Thessaloniki</span></p>
<p class="toc2"><span href="#/13_Chapter_05" title="Link target outside of Sample">Miracles on the Ramparts</span></p>
<p class="toc2"><span href="#/14_Chapter_06" title="Link target outside of Sample">History is the Dogma of Scars</span></p>
<p class="toc2"><span href="#/15_Chapter_07" title="Link target outside of Sample">Demetrius among the Macedonians</span></p>
<p class="toc2"><span href="#/16_Chapter_08" title="Link target outside of Sample">Demetrius among the Serbs</span></p>
<p class="toc2"><span href="#/17_Chapter_09" title="Link target outside of Sample">Demetrius among the Bulgarians</span></p>
<p class="toc2"><span href="#/18_Chapter_10" title="Link target outside of Sample">Who is He Killing?</span></p>
<p class="toc2"><span href="#/19_Chapter_11" title="Link target outside of Sample">Letting Go</span></p>
<p class="toc2"><span href="#/20_Chapter_12" title="Link target outside of Sample">Lord, have Mercy</span></p>
<p class="toc2"><span href="#/21_Chapter_13" title="Link target outside of Sample">Return to Canada</span></p>
<p class="toc1"><span href="#/22_part2" title="Link target outside of Sample"><span class="bolditalic">PART TWO</span>  <img alt="dot1.jpg" src="images/dot1.jpg"/>  <span class="bolditalic"> Demetrius in Byzantium</span></span></p>
<p class="toc2"><span href="#/23_Chapter_14" title="Link target outside of Sample">Interlude</span></p>
<p class="toc2"><span href="#/24_Chapter_15" title="Link target outside of Sample">Opening: The Mad Professor of Sirmium</span></p>
<p class="toc2"><span href="#/25_Chapter_16" title="Link target outside of Sample">Slavs in Byzantium</span></p>
<p class="toc2"><span href="#/26_Chapter_17" title="Link target outside of Sample">The Byzantine Saint</span></p>
<p class="toc2"><span href="#/27_Chapter_18" title="Link target outside of Sample">The Guardian Saint</span></p>
<p class="toc2"><span href="#/28_Chapter_19" title="Link target outside of Sample">The Passion of Demetrius</span></p>
<p class="toc2"><span href="#/29_Chapter_20" title="Link target outside of Sample">The Life and Death of St. Demetrius, a Young Man of 	 	Thessalonica, April 304 (Two Versions)</span></p>
<p class="toc1"><span href="#/30_Epilogue" title="Link target outside of Sample"><em class="italic">Epilogue</em></span></p>
<p class="toc2"><span href="#/31_Acknowledgements" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></p>
<p class="toc2"><span href="#/32_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></p>
<p class="toc2"><span href="#/33_Bibliography_Reading" title="Link target outside of Sample"><em class="italic">Bibliography and Recommended Reading</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?43c4384a